import React from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import { injectIntl } from 'react-intl';
import { Droppable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import {
  PanelGroup,
  Panel,
  ButtonGroup,
  Button,
  Collapse
} from 'react-bootstrap';

import Todo from './Todo';
// import {CAN_DELETE_TODO_LIST, CAN_SAVE_TODO_LIST} from "./authorization";
import TodosSavePanel from './TodosSavePanel';
import TodosLoadPanel from './TodosLoadPanel';
import TodosDeleteButton from './TodosDeleteButton';

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? '#FAFAFA' : 'transparent'
  // transform: "translateX(-10%)"
});

@injectIntl
@inject('rootStore')
@observer
export default class Todos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.canDeleteTodoList = props.rootStore.authorizationStore.canDeleteTodoList(
      props.note
    );
    this.canSaveTodoList = props.rootStore.authorizationStore.canSaveTodoList;
    this.canCreateTodoListItem = props.rootStore.authorizationStore.canCreateTodoListItem(
      props.note
    );
  }

  @observable todoText = '';
  @observable showTodoInput = false;
  @observable openSplitButton = false;

  render() {
    const { note, intl } = this.props;

    if (!note.todoList) {
      return null;
    }

    return (
      <div className="note-todos-container">
        {!this.showTodoInput && this.renderButton()}
        {this.showTodoInput && (
          <TextareaAutosize
            className="form-control"
            type="text"
            autoFocus={true}
            onChange={action(e => (this.todoText = e.target.value))}
            onKeyDown={this.handleKeyDown}
            onBlur={this.finishEdit}
            value={this.todoText}
          />
        )}

        <Droppable
          droppableId={`${note.laneStore.name} ${note.laneStore.notes.indexOf(
            note
          )}`}
          type={'TODO'}
        >
          {(provided, snapshot) => (
            <div
              className=""
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
              key={note.id}
            >
              <TodosRender note={note} />
            </div>
          )}
        </Droppable>
      </div>
    );
  }

  renderButton = () => {
    const { note, intl } = this.props;
    const { formatMessage } = intl;

    const disabled = !this.canCreateTodoListItem;
    const buttonFaClass = note.showTodoManagePanel
      ? 'fa fa-caret-up'
      : 'fa fa-caret-down';

    return (
      <div>
        <ButtonGroup>
          <Button
            bsStyle={'primary'}
            onClick={this.toggleTodoInput}
            style={{ marginBottom: '15px' }}
            disabled={disabled}
          >
            {intl.formatMessage({ id: 'add_todo_item' })}
          </Button>
          <Button
            bsStyle="primary"
            onClick={() => note.toggleTodoManagePanel()}
            disabled={disabled}
          >
            <i className={buttonFaClass} aria-hidden="true" />
          </Button>
        </ButtonGroup>

        {this.renderOptions()}
      </div>
    );
  };

  renderOptions = () => {
    const { intl, note } = this.props;

    const saveDisabled =
      note.todoList.items.length < 1 || !this.canSaveTodoList;
    const loadDisabled = note.cardTodoLists.length < 1;
    const showDeleteButton = !!(
      this.canDeleteTodoList &&
      note.todoList &&
      note.todoList.items.length
    );

    return (
      <Collapse
        className="note-todos-collapse-container"
        in={note.showTodoManagePanel}
      >
        <Panel>
          <PanelGroup accordion>
            {!loadDisabled && (
              <Panel header={intl.formatMessage({ id: 'load' })} eventKey="1">
                <TodosLoadPanel note={note} />
              </Panel>
            )}

            {!saveDisabled && (
              <Panel header={intl.formatMessage({ id: 'save' })} eventKey="2">
                <TodosSavePanel note={note} />
              </Panel>
            )}
          </PanelGroup>

          {showDeleteButton && (
            <React.Fragment>
              <hr />
              <TodosDeleteButton
                note={note}
                onDelete={this.deleteTodoListItems}
              />
            </React.Fragment>
          )}
        </Panel>
      </Collapse>
    );
  };

  @action deleteTodoListItems = () => {
    const { note } = this.props;

    note.deleteTodoListItems();
    note.toggleTodoManagePanel();
  };

  @action
  addTodo = () => {
    const { note } = this.props;

    note.addTodoItem(this.todoText);

    this.todoText = '';
  };

  @action
  handleKeyDown = e => {
    if (e.key === 'Enter') {
      this.finishEdit(e);
    }
  };

  @action
  finishEdit = e => {
    e.preventDefault();

    if (this.todoText) {
      this.addTodo();

      if (e.type === 'blur') {
        this.hideTodoInput(e);
      }
    } else {
      this.hideTodoInput(e);
    }
  };

  @action
  hideTodoInput = e => {
    this.showTodoInput = false;
  };

  @action
  toggleTodoInput = () => {
    this.showTodoInput = !this.showTodoInput;
  };

  @action toggleSplitButton = () => {
    this.openSplitButton = !this.openSplitButton;
  };
}

@observer
class TodosRender extends React.Component {
  render() {
    const { note } = this.props;

    return note.todoList.items.map((item, index) => (
      <Todo item={item} note={note} key={index} index={index} />
    ));
  }
}

TodosRender.propTypes = {
  note: PropTypes.object.isRequired
};

Todos.propTypes = {
  note: PropTypes.object.isRequired
};
